module.exports = __webpack_public_path__ + "static/media/vtex11.52a541a0.png";